import styled, { css } from 'styled-components';

import { fontSize, FontSizes, fontWeight, FontWeights, minWidth, TextButton } from '@calm-web/design-system';

export const navItemTypography = css`
	${fontSize(FontSizes.xl)}
	${fontWeight(FontWeights.Medium)}

	${minWidth('desktop')} {
		${fontSize(FontSizes.base)}
		${fontWeight(FontWeights.Demi)}
	}
`;

export const Wrapper = styled(TextButton).attrs({
	hideUnderline: true,
})`
	&& {
		${navItemTypography}
	}
`;
